/*
 * @Author: zhang lin
 * @Date: 2022-04-14 15:26:18
 * @LastEditors: zhang lin
 * @LastEditTime: 2022-10-27 14:47:44
 * @Description: file content
 */

import React from 'react';
import classnames from 'classnames';
import 'root/assets/icons/iconfont';

const Icon = (props: any) => {
  const { type, className, style, other, title, onClick } = props;
  const classname = classnames({ [`${className}`]: className !== undefined });
  return (
    <label
      title={title}
      className={classname}
      onClick={() => {
        if (onClick) {
          onClick();
        }
      }}
    >
      <svg className="icon svg-icon" aria-hidden="true" style={style} {...other}>
        <use xlinkHref={`#${type}`} />
      </svg>
    </label>
  );
};

export default Icon;
